import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Container, Typography } from "@mui/material"
import CustomImage from "../../components/custom-image/custom-image.component"
import Timeline from "../../assets/timeline.svg"

import BackgroundPattern from "../../components/background-pattern/background-pattern.component"
export const Section = styled(SectionWrapper)`
  #first,
  #second,
  #third {
    visibility: hidden;
  }
`

export const Wrapper = styled(Container)``

export const InfoContainer = styled.div`
  border-radius: 32px;
  background: #e5f6f2;
  position: relative;
`

export const Pattern = styled(BackgroundPattern)``

export const ContentContainer = styled.div`
  position: relative;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;

  ${({ theme }) => theme.breakpoints.up(1024)} {
    padding: ${({ theme }) => theme.typography.pxToRem(150)};
  }
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: ${({ theme }) => theme.typography.pxToRem(60)};
  row-gap: 24px;
`

export const TopTitle = styled(Typography)`
  color: #027458;
  text-align: center;
  font-size: ${({ theme }) => theme.typography.pxToRem(15)};
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.45px;
  text-transform: uppercase;
`

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.main};
  text-align: center;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.52px;
  font-size: ${({ theme }) => theme.typography.pxToRem(28)};
  line-height: ${({ theme }) => theme.typography.pxToRem(38)};
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(89)};
  font-weight: 500;

  ${({ theme }) => theme.breakpoints.up("md")} {
    max-width: 835px;
    line-height: ${({ theme }) => theme.typography.pxToRem(64)};
    margin-bottom: ${({ theme }) => theme.typography.pxToRem(127)};
    font-size: ${({ theme }) => theme.typography.pxToRem(52)};
    font-weight: 400;
  }
`

export const FeatureContainer = styled.div`
  ${({ theme }) => theme.breakpoints.up(950)} {
    &.right {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: end;
    }
  }
`

export const CardContainer = styled.div`
  padding-left: 3rem;
  margin-bottom: 3rem;
  padding-right: 0.5rem;

  ${({ theme }) => theme.breakpoints.up(950)} {
    padding-left: 0;
    margin-bottom: 0;
    padding-right: 0;
    width: 50%;
    height: 100%;

    &.right {
      padding-left: ${({ theme }) => theme.typography.pxToRem(130)};
    }
  }
`

export const Image = styled(CustomImage)`
  max-width: 287px !important;
  img {
    max-height: 140px;
    ${({ theme }) => theme.breakpoints.up("sm")} {
      max-height: unset;
    }
  }
`

export const Description = styled.div`
  max-width: 416px;
  margin-top: ${({ theme }) => theme.typography.pxToRem(52)};
  p,
  strong {
    color: #2b3332;
    font-size: ${({ theme }) => theme.typography.pxToRem(18)};
    font-style: normal;
    font-weight: 400;
    line-height: ${({ theme }) => theme.typography.pxToRem(30)};
  }

  strong {
    color: #129a78;
    font-weight: 700;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    margin-top: ${({ theme }) => theme.typography.pxToRem(44)};
    p,
    strong {
      font-size: ${({ theme }) => theme.typography.pxToRem(17)};
      line-height: ${({ theme }) => theme.typography.pxToRem(26)};
    }
  }
`

export const FeaturesWrapper = styled.div`
  position: relative;
`

export const ProgressImage = styled(Timeline)`
  width: 36px;
  height: 1055px;
  position: absolute;
  left: 50%;
  top: 0;

  ${({ theme }) => theme.breakpoints.down(950)} {
    left: 0;
  }
`
